module.exports = __webpack_public_path__ + "414c3f71bb58882ed5411b654dbb90ca.svg";